export const sliderData = [
    {
        img: "https://i.ibb.co/9Th1dsz/the-aw-creative-digital-marketing-Ds-Kc-WDk6-NEU-unsplash.jpg",
        id: 1,
        title:"women Fashion",
        desc : "Women fashion"
    },
    {
        img: "https://i.ibb.co/yNk4SmJ/kai-gabriel-De-Umcgcf3is-unsplash.jpg",
        id: 2,
        title:"Men Fashion",
        desc : "Fashion"
    },
    {
        img: "https://i.ibb.co/Gv8B1Dz/mojtaba-fahiminia-t4g1gct-Aa-Kk-unsplash.jpg",
        id: 3,
        title:"Shoes Fashion",
        desc : "shoes"
    },
    {
        img: " https://i.ibb.co/FgbjdV5/ryan-plomp-jvo-Z-Aux9aw-unsplash.jpg",
        id: 4,
        title:"Classic unisex shoes",
        desc : "Shoes"
    },
]
 
export const storeItems = [
    {
        img: "https://i.ibb.co/Jk6JN0t/p3.png",
        id: 1,
        title:"women Fashion",
        desc : "Women fashion"
    },
    {
        img: "https://i.ibb.co/yNk4SmJ/kai-gabriel-De-Umcgcf3is-unsplash.jpg",
        id: 2,
        title:"Men Fashion",
        desc : "Fashion"
    },
    {
        img: "https://i.ibb.co/ZYK1Dp1/p3-removebg-preview.png",
        id: 3,
        category:"phone",
        title:"Samsung Phone",
        desc : "shoes"
    },
    {
        img: "https://i.ibb.co/s5JSPwp/tecno-removebg-preview.png",
        id: 4,
        title:"Techno phone",
        desc : "Shoes",
        category: ""
    },
    {
        img: "https://i.ibb.co/7n4YYWV/mi-removebg-preview.png",
        id: 5,
        title:"Classic unisex shoes",
        desc : "",
        category: ""
    },  
      {
        img: " https://i.ibb.co/FgbjdV5/ryan-plomp-jvo-Z-Aux9aw-unsplash.jpg",
        id: 4,
        title:"Classic unisex shoes",
        desc : "Shoes",
        category: ""
    },  
      {
        img: " https://i.ibb.co/FgbjdV5/ryan-plomp-jvo-Z-Aux9aw-unsplash.jpg",
        id: 4,
        title:"Classic unisex shoes",
        desc : "Shoes",
        category: ""
    },    {
        img: " https://i.ibb.co/FgbjdV5/ryan-plomp-jvo-Z-Aux9aw-unsplash.jpg",
        id: 4,
        title:"Classic unisex shoes",
        desc : "Shoes",
        category: ""
    },
    {
        img: " https://i.ibb.co/FgbjdV5/ryan-plomp-jvo-Z-Aux9aw-unsplash.jpg",
        id: 4,
        title:"Classic unisex shoes",
        desc : "Shoes",
        category: ""
    },
    {
        img: " https://i.ibb.co/FgbjdV5/ryan-plomp-jvo-Z-Aux9aw-unsplash.jpg",
        id: 4,
        title:"Classic unisex shoes",
        desc : "Shoes",
        category: ""
    },
    {
        img: " https://i.ibb.co/FgbjdV5/ryan-plomp-jvo-Z-Aux9aw-unsplash.jpg",
        id: 4,
        title:"Classic unisex shoes",
        desc : "Shoes",
        category: ""
    },
    {
        img: " https://i.ibb.co/FgbjdV5/ryan-plomp-jvo-Z-Aux9aw-unsplash.jpg",
        id: 4,
        title:"Classic unisex shoes",
        desc : "Shoes",
        category: ""
    },
    {
        img: " https://i.ibb.co/FgbjdV5/ryan-plomp-jvo-Z-Aux9aw-unsplash.jpg",
        id: 4,
        title:"Classic unisex shoes",
        desc : "Shoes",
        category: ""
    },
    {
        img: " https://i.ibb.co/FgbjdV5/ryan-plomp-jvo-Z-Aux9aw-unsplash.jpg",
        id: 4,
        title:"Classic unisex shoes",
        desc : "Shoes",
        category: ""
    },
    {
        img: " https://i.ibb.co/FgbjdV5/ryan-plomp-jvo-Z-Aux9aw-unsplash.jpg",
        id: 4,
        title:"Classic unisex shoes",
        desc : "Shoes",
        category: ""
    },
    {
        img: " https://i.ibb.co/FgbjdV5/ryan-plomp-jvo-Z-Aux9aw-unsplash.jpg",
        id: 4,
        title:"Classic unisex shoes",
        desc : "Shoes",
        category: ""
    },
    {
        img: " https://i.ibb.co/FgbjdV5/ryan-plomp-jvo-Z-Aux9aw-unsplash.jpg",
        id: 4,
        title:"Classic unisex shoes",
        desc : "Shoes",
        category: ""
    },
    {
        img: " https://i.ibb.co/FgbjdV5/ryan-plomp-jvo-Z-Aux9aw-unsplash.jpg",
        id: 4,
        title:"Classic unisex shoes",
        desc : "Shoes",
        category: ""
    },
    {
        img: " https://i.ibb.co/FgbjdV5/ryan-plomp-jvo-Z-Aux9aw-unsplash.jpg",
        id: 4,
        title:"Classic unisex shoes",
        desc : "Shoes",
        category: ""
    },
    {
        img: " https://i.ibb.co/FgbjdV5/ryan-plomp-jvo-Z-Aux9aw-unsplash.jpg",
        id: 4,
        title:"Classic unisex shoes",
        desc : "Shoes",
        category: ""
    },
    {
        img: " https://i.ibb.co/FgbjdV5/ryan-plomp-jvo-Z-Aux9aw-unsplash.jpg",
        id: 4,
        title:"Classic unisex shoes",
        desc : "Shoes",
        category: ""
    },
    {
        img: " https://i.ibb.co/FgbjdV5/ryan-plomp-jvo-Z-Aux9aw-unsplash.jpg",
        id: 4,
        title:"Classic unisex shoes",
        desc : "Shoes",
        category: ""
    },

    
];





























// https://i.ibb.co/2gwX3QM/the-aw-creative-digital-marketing-Ds-Kc-WDk6-NEU-unsplash-removebg-preview.png
// https://i.ibb.co/vjbxyD4/giorgio-trovato-8kr-X0-Hk-Xw8c-unsplash-removebg-preview.png
// https://i.ibb.co/kXbBv4R/erick-cerritos-i5-UV2-Hp-ITYA-unsplash-removebg-preview.png
// https://i.ibb.co/JkqcJwj/howard-bouchevereau-RSCir-J70-NDM-unsplash-removebg-preview.png
// https://i.ibb.co/cyFdhnM/l1-removebg-preview.png
// https://i.ibb.co/ph43w2L/l2-removebg-preview.png
// https://i.ibb.co/mHtFGMw/p1-removebg-preview.png
// https://i.ibb.co/NTsvBMz/p2-removebg-preview.png
// https://i.ibb.co/qMcY6H3/nokia-removebg-preview.png
// https://i.ibb.co/ZYK1Dp1/p3-removebg-preview.png
// https://i.ibb.co/s5JSPwp/tecno-removebg-preview.png
// https://i.ibb.co/7n4YYWV/mi-removebg-preview.png
// https://i.ibb.co/9wsqJ9y/p5-removebg-preview.png
// https://i.ibb.co/9Th1dsz/the-aw-creative-digital-marketing-Ds-Kc-WDk6-NEU-unsplash.jpg
// https://i.ibb.co/yNk4SmJ/kai-gabriel-De-Umcgcf3is-unsplash.jpg
// https://i.ibb.co/PCMnjpH/pedro-miranda-n-AJWJNh2-UFI-unsplash.jpg
// https://i.ibb.co/FgXQznx/mohamad-khosravi-d54wbtjedog-unsplash.jpg
// https://i.ibb.co/TgYpgc8/drake-s-takes-v-Kn-RYW-mtek-unsplash.jpg
// https://i.ibb.co/W3Bx13S/mohamad-khosravi-Uw3-Of-Kz2-J-0-unsplash.jpg
// https://i.ibb.co/Gv8B1Dz/mojtaba-fahiminia-t4g1gct-Aa-Kk-unsplash.jpg
// https://i.ibb.co/FgbjdV5/ryan-plomp-jvo-Z-Aux9aw-unsplash.jpg
// https://i.ibb.co/Hn2msmZ/revolt-164-6w-VEHf-I-unsplash.jpg